import { render, staticRenderFns } from "./UnpaidBookings.vue?vue&type=template&id=12d0dfe2"
import script from "./UnpaidBookings.vue?vue&type=script&lang=js"
export * from "./UnpaidBookings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports